import { useEffect } from "react";
import { FaPencilAlt } from "react-icons/fa";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import {
  getUserDetailsStore,
  setUserDetailsStore,
  useUserDetailsStore,
} from "../../..";
import { DP } from "../../../../../common/types";
import {
  UCancelButton,
  USaveButton,
  UTextarea,
} from "../../../../../UI/UForma";
import { fetchDescEdit } from "../../../api";

interface Props extends DP {}

const WriteAbout = (props: Props) => {
  const isDescriptionEditing = useUserDetailsStore(
    (s) => s.isDescriptionEditing
  );
  const isDescEditFormLoading = useUserDetailsStore(
    (s) => s.isDescEditFormLoading
  );
	const descInput = useUserDetailsStore((s) => s.descInput)

  useEffect(() => {
    return () => {
      setUserDetailsStore({ isDescriptionEditing: false });
    };
  }, []);

  const handleChangeEditing = () => {
    setUserDetailsStore({ isDescriptionEditing: true });
  };
  const handleClose = () => {
    setUserDetailsStore({ isDescriptionEditing: false });
  };
  const handleSave = () => {
    if (getUserDetailsStore().descInput.length) {
      fetchDescEdit();
    }
    setUserDetailsStore({ isDescriptionEditing: true });
  };
  const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setUserDetailsStore({ descInput: e.target.value });
  };

  return (
    <Wrapper className={props.className}>
      {isDescriptionEditing ? (
        <FormaWrapper>
          <UTextarea value={descInput} onChange={handleInput} />
          <UCancelButton disabled={isDescEditFormLoading} onClick={handleClose}>
            Cancel
          </UCancelButton>
          <USaveButton disabled={isDescEditFormLoading} onClick={handleSave}>
            Save
          </USaveButton>
        </FormaWrapper>
      ) : (
        <Button onClick={handleChangeEditing}>
          <FaPencilAlt />
          <span>Write about yourself</span>
        </Button>
      )}
    </Wrapper>
  );
};

const FormaWrapper = styled.div(() => [
  tw`flex relative items-end space-x-0.5`,
  css`
    ${UTextarea} {
      ${tw`w-full px-0.5 text-[0.4rem] grow outline`}
    }
    & > button {
      ${tw`absolute h-3 right-0 bottom-[-1rem]`}
    }
    & > button:last-child {
      ${tw`right-6`}
    }
  `,
]);

const Wrapper = styled.div(() => [tw`text-[0.3rem]`]);

const Button = styled.button(() => [tw`flex space-x-0.5 italic opacity-30`]);

export default styled(WriteAbout)``;
